module.exports = __webpack_public_path__ + "media/images/icon-haccps-confirmation-5b1345e8c14e364eed0638e1cdcdd82d.svg";